import React from "react";
import styles from "../../DeviceHealth/FrequencyBucketTable.module.css";
import tableStyles from "./DeviceStateCityTable.module.css";
import { SWITCHES, formatDuration, getIntervalStatus } from "../deviceStates";

// Shared by the Device Health state table and its depot popover.

const onOff = (value) => (value ? "ON" : "OFF");

// ON / OFF tag for one switch (Emergency ON is red)
export function StatusTag({ item, on }) {
    const tone = !on ? tableStyles.statusOff : item.danger ? tableStyles.statusDanger : tableStyles.statusOn;
    return <span className={`${tableStyles.statusTag} ${tone}`}>{onOff(on)}</span>;
}

// Mains / Ignition / Emergency cells for a switch combination
export function StatusCells({ values }) {
    return SWITCHES.map((s) => (
        <td key={s.key}>
            <StatusTag item={s} on={values[s.key]} />
        </td>
    ));
}

const INTERVAL_TONE = {
    good: tableStyles.intervalGood,
    bad: tableStyles.intervalBad,
    none: tableStyles.intervalNone
};

// interval colour (city, depot and vehicle rows): green up to the standard, red above it,
// grey when nothing reported
export const intervalToneClass = (actual, standard) => INTERVAL_TONE[getIntervalStatus(actual, standard)];

// Actual (today) interval cell
export function IntervalCell({ actual, standard }) {
    return (
        <td className={`${styles.bucketCell} ${intervalToneClass(actual, standard)}`}>
            {formatDuration(actual)}
        </td>
    );
}

// "Actual (today)" header with the switch combination's standard as a highlighted badge;
// keyed by the value so the badge flashes when a switch changes it
export function IntervalHeader({ standard }) {
    return (
        <th title="Today's average interval; the badge is the standard for the selected switches">
            <span className={tableStyles.switchHeader}>
                Actual (today)
                <span key={standard ?? "none"} className={tableStyles.stdBadge}>
                    Std {standard === null ? "–" : formatDuration(standard)}
                </span>
            </span>
        </th>
    );
}

// label + ON / OFF switch, for the popover toolbar
export function SwitchChip({ item, checked, onToggle }) {
    const stateClass = !checked
        ? ""
        : item.danger ? tableStyles.chipStateDanger : tableStyles.chipStateOn;

    return (
        <span className={tableStyles.switchChip}>
            {item.label}
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={`${item.label} status`}
                className={`${tableStyles.headerSwitch} ${tableStyles.chipSwitch} ${checked ? tableStyles.headerSwitchOn : ""} ${item.danger ? tableStyles.headerSwitchDanger : ""}`}
                onClick={onToggle}
            />
            <span className={`${tableStyles.chipState} ${stateClass}`}>{onOff(checked)}</span>
        </span>
    );
}

// column header with its own ON / OFF switch (same state as the card switches)
export function SwitchHeader({ item, checked, onToggle }) {
    return (
        <th>
            <span className={tableStyles.switchHeader}>
                {item.label} Status
                <span className={tableStyles.headerSwitchRow}>
                    <button
                        type="button"
                        role="switch"
                        aria-checked={checked}
                        aria-label={`${item.label} status`}
                        className={`${tableStyles.headerSwitch} ${checked ? tableStyles.headerSwitchOn : ""} ${item.danger ? tableStyles.headerSwitchDanger : ""}`}
                        onClick={onToggle}
                    />
                    <span className={tableStyles.headerSwitchState}>{onOff(checked)}</span>
                </span>
            </span>
        </th>
    );
}
